import * as React from 'react';
import {
  FlexRowCenterVertical,
  FlexColCenter,
} from '../../Defaults/Flexbox/Flexbox';
import styled from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import { SvgIcon, IconType } from '../General/SvgIcon';

interface Props {
  currentView: string;
  changeView: () => void;
}

function ViewSwitcher({ currentView, changeView }: Props) {
  const isCard = currentView === 'card';
  const isList = !isCard;

  return (
    <Wrapper>
      <IconWrapper active={isCard} onClick={isCard ? null : changeView}>
        <SvgIcon
          viewBox="0 0 22 22"
          icon={IconType.cardView}
          title="Prepnutie na kartové zobrazenie"
          alt="Prepnutie na kartové zobrazenie"
          cursor={isCard ? 'initial' : 'pointer'}
          fill={isCard ? '' : '#CCCCCC'}
        />
      </IconWrapper>
      <SecondIconWrapper active={isList} onClick={isList ? null : changeView}>
        <SvgIcon
          viewBox="0 0 22 18"
          icon={IconType.listView}
          title="Prepnutie na listové zobrazenie"
          alt="Prepnutie na listové zobrazenie"
          cursor={isList ? 'initial' : 'pointer'}
          fill={isList ? '' : '#CCCCCC'}
        />
      </SecondIconWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenterVertical)`
  margin-bottom: ${rem(16)};
`;

const IconWrapper = styled(FlexColCenter)<{ active: boolean }>`
  transition: all 0.2s ease;
  cursor: pointer;
  padding: ${rem(12)};
  border-radius: ${rem(1)} 0 0 ${rem(1)};
  border: ${rem(1)} solid #cccccc;
  box-shadow: ${({ theme }) => theme.boxShadow.default};
  background-color: ${props =>
    props.active
      ? props.theme.colors.paginationSecondary
      : props.theme.colors.white};
  width: ${rem(47)};
`;

const SecondIconWrapper = styled(IconWrapper)`
  border-radius: 0 ${rem(1)} ${rem(1)} 0;
  border-left: 0;
`;

export { ViewSwitcher };
